import styled from 'styled-components'
import Panel from '@/components/panel'
import { breakpoints, colors, fontWeights } from '@/styles'
import { Label, Row } from '@/components/form'

export const StyledPanel = styled(Panel)`
  text-align: left;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    margin: 0px;
  }
`

export const StyledRow = styled(Row)<{ borderTop?: boolean }>`
  justify-content: space-between;
  align-items: center;
  margin-left: 0;
  margin-right: 0;
  border-top: ${props => (props.borderTop ? 1 : 0)}px solid ${colors.grey};
`

export const StyledLabel = styled(Label)<{ bold?: string }>`
  flex: 1;
  margin-right: 20px;

  ${props =>
    props.bold &&
    `
      font-weight: ${fontWeights.medium};
  `}
`
